import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import uuid from 'uuid'
import styles from './checkbox.styl'

export default class Checkbox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    justify: PropTypes.bool,
    html: PropTypes.bool,
    labelless: PropTypes.bool,
    inTable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    intlKey: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    intlValues: PropTypes.object
  }

  static defaultProps = {
    disabled: false,
    labelless: false,
    html: false
  }

  handleChange = e => {
    if (this.props.onChange) {
      this.props.onChange(e.target.checked)
    }
  }

  render() {
    const {
      label,
      justify,
      checked,
      disabled,
      html,
      intlKey,
      intlValues,
      labelless,
      name
    } = this.props
    const key = uuid.v1()
    const justifyClass = justify ? styles.justify : ''
    const disabledClass = disabled ? styles.disabled : ''
    const srOnlyClass = labelless ? 'sr-only' : ''
    const { inTable } = this.props
    const inTableClass = inTable ? styles.inTable : ''
    const labellessClass = labelless ? 'labelless' : ''

    return (
      <div className={`form-group ${inTableClass} ${labellessClass}`}>
        <div className={`${styles.controls} ${justifyClass} ${disabledClass}`}>
          <input
            className={`form-control ${styles.formControl}`}
            type="checkbox"
            id={key}
            disabled={disabled}
            checked={checked || false}
            onChange={this.handleChange}
            name={name}
          />
          <label className={`control-label ${styles.controlLabel}`} htmlFor={key}>
            <span className={srOnlyClass}>
              {intlKey && html &&
                <FormattedHTMLMessage
                  id={intlKey}
                  defaultMessage={label}
                  values={intlValues}
                  />
              }
              {intlKey && !html &&
              <FormattedMessage
                id={intlKey}
                defaultMessage={label}
                values={intlValues}
              />
              }
              {!intlKey &&
                label
              }
            </span>
          </label>
        </div>
      </div>
    )
  }
}
